<template>
  <div class="cx_editPanel">
    <div class="cx_editPanel_left" :class="{ cx_vertical_fill: scroll0 == 'hidden'}">
      <slot name="left"></slot>
    </div>
    <div class="cx_editPanel_right" :class="{ cx_vertical_fill: scroll1 == 'hidden' }">
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import resize from 'vue-resize-directive';
import * as Components from '@/agiles/components';

@Component({
  directives: {
    resize,
  },
})
export default class EditPanel extends Vue {
  @Prop() scroll0: string;
  @Prop() scroll1: string;
}
</script>
<style lang="scss">
@import '@/agiles/components/style.scss';
.cx_editPanel {
  @extend .cx_vertical_scroll;
  flex: 1;
  display: flex;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  // justify-content: space-around;
  height: 100%;
  .cx_spmode & {
    flex-direction: column;
    height: unset;
  }

  .cx_editPanel_left,
  .cx_editPanel_right,
  .cx_editPanel_vertical {
    // @extend .cx_vertical_scroll;
    padding-top: 5px;
    flex: 1;
    // overflow-y: auto;
    // overflow-x: hidden;
    padding-left: 30px;
    padding-right: 30px;
    min-width: 390px;  //iphone
    height: fit-content;    
    min-height: 100%;

    .cx_spmode & {
      min-height: unset;
      flex:unset;
    }
  }
  .cx_editPanel_left {
    border-right: thin solid rgb(228, 227, 227);

    .cx_spmode & {
      border-right: none;
    }
  }
  .cx_editPanel_vertical {
    // padding-right: 20px;
    display: block;
  }
}
</style>
